export const en = {
  cancel: 'Cancel',
  confirm: 'Confirm',
  search: 'Search',
  clear: 'Clear',
  noData: 'No data to show',
  save: 'Save',
  run: 'Run',
  add: 'Add',
  back: 'Back',
  delete: 'Delete',
  update: 'Update',
  next: 'Next',
  options: 'Options',
  other: 'Other',
  choose: 'Choose',
  edit: 'Edit',
  elementSelected: 'element selected. | elements selected. ',
  details: 'Details',
  import: 'Import',
  id: 'Id',
  page: 'Page',
  loadOthers: 'Load others',
  previous: 'Previous',
  filters: 'Filters',

  column: {
    archiveNumber: 'Archive number',
    authority: 'Authority',
    color: 'Color',
    createdAt: 'Creation date',
    date: 'Date',
    description: 'Description',
    displayName: 'Name',
    documents: 'Documents',
    email: 'E-mail',
    externalId: 'Practice id',
    filename: 'Filename',
    icon: 'Icon',
    id: 'Id',
    index: 'Index',
    judicialData: 'Judicial data',
    key: 'Key',
    pec: 'PEC',
    permissions: 'Permissions',
    phase: 'Phase',
    practiceName: 'Practice name',
    response: 'Response',
    roles: 'Roles',
    sentAt: 'Sending date',
    site: 'Site',
    source: 'Source',
    status: 'Status',
    telephone: 'Telephone',
    type: 'Type',
    user: 'User',
    users: 'Users',
    value: 'Value',
    values: 'Values',
    vatCode: 'VAT CODE',
    visible: 'Visible',
    writeOnly: 'Sensitive',
  },

  toast: {
    success: 'Success',
    error: 'Error',
    warn: 'Warning',
    genericSuccess: 'Operation completed successfully!',
    genericError: 'Oops, something went wrong!',
    created: 'Data saved successfully!',
    updated: 'Data updated successfully!',
    removed: 'Data removed successfully!',
  },

  duration: {
    days: 'day | days',
    hours: 'hour | hours',
    minutes: 'minute | minutes',
    seconds: 'second | seconds',
    Days: 'day | days',
    Hours: 'hour | hours',
    Minutes: 'minute | minutes',
    Seconds: 'second | seconds',
    Weeks: 'week | weeks',
    Months: 'month | months',
    Years: 'year | years',
  },

  login: {
    header: 'Welcome!',
    tenant: 'Tenant',
    username: 'Username',
    password: 'Password',
    button: 'Login',
    accessDenied: 'Login failed. Check your details and try again.',
  },

  logout: {
    button: 'Logout',
    dialogMessage: 'Are you sure you want to log-out?',
    header: 'Logout',
    confirm: 'Logout',
  },

  validations: {
    email: 'This field should be a valid e-mail address',
    generalRoleNumber: 'This field should be a general role number in the format N/YYYY or N-N/YYYY',
    identifier: 'This field can contain only alphanumeric characters (a-z, A-Z, 0-9) and underscores (_)',
    archiveNumber:
      'This field can contain only alphanumeric characters (a-z, A-Z, 0-9), spaces, hyphens (-) and underscores (_)',
    minLength: 'This field should be at least {min} characters long',
    notIn: 'This field cannot be one of the following: {values}',
    required: 'This field is required',
    telephone: 'This field should be a valid telephone number',
    fiscalCode: 'This field should be a valid fiscal code',
    vatCode: 'This field should be a valid VAT code',
    phaseTooltip: 'Please select the type of practice first',
    url: 'This field should be a valid URL, starting with https://',
    courtOfficeCode: 'This field should be a valid court office code, made of 10 or 11 digits',
    maxFileSize: 'The file size should not exceed {size} MB',
  },

  sidebar: {
    apb: 'APB',
    apbPractices: 'APB practices',
    apbProcessedEmails: 'APB e-mails',
    case: 'Case',
    caseDetailsEvents: 'Events',
    caseDetailsRecords: 'Records',
    caseDetailsSubjectRecords: 'Records',
    caseDetailsSubjects: 'Subjects',
    caseRecordTypes: 'Case record types',
    cases: 'Cases',
    courts: 'Courts',
    deadlineBadges: 'Deadline badges',
    deadlines: 'Deadlines',
    details: 'Details',
    duplicateMerge: 'Duplicate merge',
    edit: 'Edit',
    emailCampaigns: 'E-mail campaigns',
    home: 'Home',
    massiveEmailEvents: 'Events',
    massiveEmailMetadata: 'Metadata',
    massiveEmails: 'Massive e-mails',
    massiveEmailTypes: 'Massive e-mail types',
    massiveImports: 'Massive imports',
    new_f: 'New',
    new_m: 'New',
    parties: 'Parties',
    pct: 'Polisweb',
    pctDeposits: 'Remote Deposits',
    pctEvents: 'Polisweb Events',
    personLinks: 'Person links',
    persons: 'Persons',
    portfolios: 'Portfolios',
    practiceDetailsDeadlines: 'Deadlines',
    practiceDetailsEvents: 'Events',
    practiceDetailsPctEvents: 'Polisweb Events',
    practiceDetailsRecords: 'Records',
    practiceDetailsSubjectRecords: 'Records',
    practiceDetailsSubjects: 'Subjects',
    practicePhases: 'Practice phases',
    practices: 'Practices',
    practiceTypeAssignmentRoles: 'Assignment roles',
    practiceTypeDeadlineTypes: 'Deadline types',
    practiceTypeRecordTools: 'Record tools',
    practiceTypeRecordTypes: 'Record types',
    practiceTypes: 'Practice types',
    preview: 'Preview',
    profile: 'Profile',
    receivers: 'Receivers',
    recordTypes: 'Record types',
    relations: 'Relations',
    reports: 'Report',
    responses: 'Responses',
    roles: 'Roles',
    settings: 'Settings',
    specificFields: 'Specific fields',
    subjectTypes: 'Subject types',
    tasks: 'Tasks',
    taskTypes: 'Task types',
    support: 'Support',
    systemManagement: 'System management',
    toolRuns: 'Tools',
    unauthorized: 'Unauthorized',
    userManagement: 'User management',
    users: 'Users',
  },

  unauthorized: {
    title: 'Unauthorized',
    body: 'You do not have the permissions to see this page!',
    solution: 'Please contact your administrator.',
  },

  home: {
    greetings: {
      morning: 'Good morning {name}!',
      afternoon: 'Good afternoon {name}!',
      evening: 'Good evening {name}!',
      night: 'Good night {name}!',
    },
    recentPractices: 'Recent practices',
    recentToolRuns: 'Recent tool runs',
    noRecentPractices: 'You have not seen any practice recently',
    noRecentToolRuns: 'No tool runs to show',
    pendingTasks: 'Tasks to do',
    noPendingTasks: 'You have no tasks to complete',
    seeAll: 'View all',
    deadlines: 'Deadlines',
    noDeadlines: 'You have no deadlines to fulfill',
    deadlineGroups: {
      expired: 'Expired',
      thisWeek: 'This week',
      thisMonth: 'This month',
      future: 'Future',
    },
    homepageSettings: {
      title: 'Homepage settings',
      practices: 'Practices',
      deadlines: 'Deadlines',
      toolRuns: 'Tool runs',
      tasks: 'Tasks',
    },
  },

  emailCampaigns: {
    title: 'E-mail campaigns',
    id: 'Id',
    name: 'Name',
    createdAt: 'Creation date',
    details: 'Details',
  },

  emailCampaignResponses: {
    id: 'Id',
    externalId: 'Practice id',
    practiceName: 'Practice name',
    email: 'E-mail',
    sentAt: 'Sending date',
    downloadResponses: 'Download responses',
  },

  users: {
    title: 'Users',
    id: 'Id',
    displayName: 'Name',
    email: 'E-mail',
    roles: 'Roles',
    add: 'Create new user',
    edit: 'Edit user',
    firstLoginPsw: 'First login password',
    resetPassword: 'Reset password',
    tooltipFirstLoginPsw: [
      'The password entered will be valid only for the first login.',
      'After the first login, the user will be required to change it and choose a new personal password.',
    ].join('\n'),
    disable: 'Disable',
    disabled: 'Disabled',
    disableHeader: 'Disable User',
    disableConfirm: 'Are you sure you want to disable {name}? The user will no longer be able to access the system.',
    enable: 'Enable',
    enabled: 'Enabled',
    enableConfirm: 'Are you sure you want to enable {name}?',
    enableHeader: 'Enable User',
    disabledInfo:
      'This user was disabled and cannot access the application anymore. To re-enable it just click the Enable button.',
  },

  roles: {
    title: 'Roles',
    table: {
      edit: 'Edit',
      id: 'Id',
      name: 'Name',
      permissions: 'Permissions',
      users: 'Users',
    },
    stepper: {
      add: 'Create new role',
      edit: 'Edit role',
      stepName: 'Name',
      roleNameStepper: {
        name: 'Name',
        description: 'Description',
        nameHelp: 'The name must be at least 3 characters.',
      },
      stepPermissions: 'Permissions',
      stepUsers: 'Users',
    },
  },

  courts: {
    title: 'Courts',
    id: 'Id',
    authority: 'Authority',
    site: 'Site',
    officeCode: 'Office code (PCT)',
    add: 'Create new court',
    edit: 'Edit court',
    editDialog: {
      header: 'Warning!',
      message: 'Renaming a court will affect all practices associated with it.',
    },
    mergeDialog: {
      title: 'Duplicate merge',
      description:
        'You are going to merge {courtName} with the one you select from the list below. This will be deleted and all its occurrences in the files will be replaced with the new court.',
      destination: 'Destination court',
      confirmMessage: 'Are you sure you want to proceed? This action is irreversible.',
      button: 'Duplicate merge',
    },
  },

  practiceTypes: {
    title: 'Practice types',
    id: 'Id',
    displayName: 'Name',
    icon: 'Icon',
    judicial: 'Judicial',
    externalIdLabel: 'External ID label',
    add: 'Create new practice type',
    edit: 'Edit practice type',
    details: 'Practice type - {name}',
    defaultPhase: 'Default phase',
    defaultPhaseName: 'Default phase name',
    defaultPhaseColor: 'Default phase color',
    phases: {
      title: 'Practice phases',
      id: 'Id',
      displayName: 'Name',
      color: 'Color',
      visible: 'Visible',
      default: 'Default',
      archiving: 'Archiving',
      add: 'Create new practice phase',
      edit: 'Edit practice phase',
      noDefaultLeft: 'You cannot leave a practice type without a default phase',
      noHiddenDefault: 'The default phase must be visible',
    },
    recordTools: {
      title: 'Record tools',
      recordTool: 'Record tool',
      add: 'Add new record tool',
      removeHeader: 'Remove',
      removeMessage: 'Are you sure you want to remove the tool "{toolName}" from the practice type?',
      autoRun: 'Automatic run',
      autoRunInfo: 'If the automatic run is set, the tool will be run on every practice or subject record update',
    },
    assignmentRoles: {
      title: 'Assignment roles',
      assignmentRole: 'Assignment role',
      add: 'Add new assignment role',
      removeHeader: 'Remove',
      removeMessage: 'Are you sure you want to remove the role "{roleName}" from the practice type?',
    },
    deadlineTypes: {
      title: 'Deadline types',
      displayName: 'Name',
      icon: 'Icon',
      color: 'Color',
      category: 'Category',
      visible: 'Visible',
      targetPhase: 'Target phase',
      add: 'Create new deadline type',
      edit: 'Edit deadline type',
    },
    recordTypesTitle: 'Record types',
  },

  specificFields: {
    key: 'Key',
    keyTooltip: 'This is the unique identifier of the field in the system and in the different exports',
    displayName: 'Name',
    type: 'Type',
    color: 'Color',
    visible: 'Visible',
    values: 'Values',
    add: 'Create new field',
    edit: 'Edit field',
    sort: 'Sort',
    hidden: 'Hidden',
    starred: 'Starred',
    starredTooltip: 'Starred fields are shown in a dedicated section in the practice details',
    types: {
      string: 'Text',
      number: 'Decimal number',
      int: 'Integer',
      eur_currency: 'Currency (€)',
      boolean: 'Checkbox',
      enum: 'Dropdown',
      date: 'Date',
      datetime: 'Date and time',
    },
  },

  settings: {
    title: 'Settings',
    name: 'Name',
    value: 'Value',
    writeOnly: 'Sensitive',
    add: 'Create new setting',
    edit: 'Edit setting',
  },

  practices: {
    title: 'Practices',
    archiveNumber: 'Archive number',
    status: 'Status',
    judicialData: 'Judicial data',
    createdAt: 'Creation date',
    displayName: 'Name',
    generalRoleNumber: 'General role number',
    parent: 'Parent practice',
    mergedInto: 'Merged practice',
    court: 'Court',
    registry: 'Registry',
    searchString: 'Search',
    practiceType: 'Practice type',
    practicePhase: 'Practice phase',
    type: 'Type',
    phase: 'Phase',
    externalId: 'External ID',
    filters: {
      title: 'Practice filters',
      searchString: 'Name or archive number',
      typePhase: 'Practice type and phase',
      externalId: 'External ID',
      judicialData: 'Judicial data',
      assignments: 'Assignments',
      unassigned: 'Unassigned',
      mine: 'Assigned to me',
      archived: 'Archived',
    },
    add: 'Create new practice',
    steps: {
      parent: 'Parent practice',
      practiceData: 'Practice data',
      cloneSubjects: 'Subjects to clone',
      summary: 'Summary',
    },
    cloneSubjects: 'Copy subjects',
    addSummary: {
      details: 'Details',
      assignments: 'User assignment',
      subjects: 'Copied subjects',
    },
  },

  portfolio: {
    title: 'Portfolios',
    add: 'Create new portfolio',
    edit: 'Edit portfolio',
    displayName: 'Name',
    caseCount: 'Cases',
    remove: {
      button: 'Delete',
      title: 'Confirm removal',
      message: 'Are you sure you want to delete "{displayName}"?',
    },
  },

  cases: {
    title: 'Cases',
    filters: {
      title: 'Case filters',
      searchString: 'Name',
      externalId: 'Identifier',
      portfolio: 'Portfolio',
      noPortfolio: 'No portfolio',
      otherPortfolios: 'Other portfolios',
    },
  },

  case: {
    add: 'Create new case',
    edit: 'Edit case',
    displayName: 'Case name',
    portfolio: 'Portfolio',
    eurValue: 'Case value',
    externalId: 'Identifier',
    createPractice: 'Create practice',
    noPractices: 'This case does not contain practices yet.',
    practices: 'Practices',
    tabs: {
      practices: 'Practices',
      events: 'Events',
      records: 'Records',
      subjects: 'Subjects',
    },
    steps: {
      case: 'Case',
      practice: 'First practice',
      userAssignments: 'User assignment',
    },
    practiceTree: {
      legend: 'Legend',
      parent: 'Parent practice',
      merge: 'Merged into',
    },
  },

  practiceDetails: {
    caseTitle: 'Case: {name}',
    title: '{type} / {name}',
    practices: 'Practices',
    details: 'Details',
    practiceType: 'Practice type',
    currentPhase: 'Current phase',
    createdAt: 'Registration date',
    externalId: 'External ID',
    archiveNumber: 'Archive number',
    eurValue: 'Practice value',
    eurValueOverride: 'Overridden practice value',
    eurValueOverrideTooltip: 'Value set manually for this practice, overriding the case value of {caseValue}',
    eurValueOverrideEditTooltip: 'Setting a value here will override the case value of {caseValue} for this practice.',
    judicialData: 'Judicial data',
    assignedUsers: 'Assigned users',
    starredSubjects: 'Highlighted subjects',
    noStarredSubjects: 'There are no highlighted subjects',
    tabs: {
      events: 'Events',
      records: 'Records',
      subjects: 'Subjects',
      pctEvents: 'PCT events',
      tasks: 'Tasks',
    },
    noPracticeSelected: {
      title: 'No practice selected',
      body: 'Please select one from the near graph',
    },
    editPhase: 'Edit practice phase',
    cancelRemainingDeadlines: 'Cancel all remaining deadlines',
    editAssignments: 'Edit practice assignments',
    editStarredSubjects: 'Edit highlighted subjects',
    subject: 'Subject',
    unassignedPractice: 'Practice without assigned users.',
    newAssignment: {
      user: 'User',
      role: 'Role',
      defaultDeadlineAssignmentTooltip: 'Whether the user will be selected as assignee on a new deadline creation',
    },
    deleteAssignmentWithDeadlines: {
      header: 'Assigned deadlines',
      message:
        'User {user} has assigned deadlines that are not yet fullfilled. Removing it from the case may leave some deadlines without a responsible assignee. Do you want to proceed?',
    },
    massiveEmails: 'Massive e-mails',
    noMassiveEmails: 'There are no massive e-mails with this practice',
    noMassiveEmailResponses: 'No responses have been recorded from:',
    deadlines: 'Deadlines',
    noDeadlines: 'There are no deadlines for this practice',
    generateArchiveNumber: 'Generate',
    edit: 'Edit practice',
    editTabs: {
      data: 'Practice data',
      relations: 'Relations',
      case: 'Case',
    },
    parentDescription:
      'Links practices connected in a hierarchical or procedural manner, representing sub-procedures or subsequent phases of a case, such as oppositions, appeals, or recalculations.',
    mergedIntoDescription:
      'Represents that this practice has been merged with another. The original practice is closed, but all operations of the main practice also apply to the merged one.',
    selectParent: 'Select parent practice',
    selectMergedInto: 'Select merged practice',
    relationsPreview: 'Preview',
    editCase: {
      case: 'Case',
      caseDescription:
        'The position represents a container of practices that belong to the same case or context. All relationships between practices, such as "parent-child" or "merged into", apply within the same position, allowing for organized management of the linked practices.',
      newCase: 'New',
      newCaseDescription: 'A new case will be created with this practice; the case name will be the practice name.',
      caseEmpty:
        'Transferring the only practice to another case will leave the current case empty, but it will not be deleted.',
      confirmHeader: 'Transfer confirm',
      confirmMessage: 'Are you sure you want to transfer "{practiceName}" to "{caseName}"?',
    },
    documents: 'Documents',
  },

  records: {
    createdBy: 'Created by',
    unknown: 'Unknown',
    runTools: 'Run tools',
    placeholders: {
      string: 'Enter a text value',
      number: 'Enter a decimal value',
      int: 'Enter an integer value',
      eur_currency: 'Enter a currency value (€)',
      boolean: 'boolean',
      enum: 'Choose a value',
      date: 'Enter a date',
      datetime: 'Enter a date and a time',
    },
    toolRunner: {
      title: 'Run record tool',
      run: 'Run',
      unavailable: 'Unavailable',
    },
    newValue: 'Value',
    add: 'Add new record',
    noRecords: 'No record has been inserted',
    addSteps: {
      recordType: 'Record type',
      payload: 'Payload',
    },
    recordType: 'Record type',
    snapshots: 'History - {typeName}',
    edit: 'Edit {typeName}',
    editConfirm: 'Confirm edit',
    editConfirmDescription:
      'Which of the following tools associated with the practice type do you want to run after the record update?',
    addDeadline: 'Add deadline for this date',
    starredTitle: 'Starred fields',
  },

  practiceEvents: {
    eventType: 'Event type',
    createdBy: 'Created by',
    eventPayload: 'Event data',
    displayName: 'Name',
    eurValueOverride: 'Overridden practice value',
    archiveNumber: 'Archive number',
    externalId: 'External ID',
    parent: 'Parent',
    mergedInto: 'Merged into',
    case: 'Case',
    unknown: 'Unknown',
    type: {
      AssignmentAdd: 'Assignment added',
      AssignmentRemove: 'Assignment removed',
      GenericEdit: 'Generic edit',
      JudicialDataEdit: 'Judicial data edited',
      SubjectAdd: 'Subject added',
      SubjectEdit: 'Subject edited',
      SubjectRemove: 'Subject removed',
      SubjectRestore: 'Subject restored',
      SubjectTransferToCase: 'Subject transferred to case',
      PhaseTransition: 'Phase transition',
      DeadlineCreation: 'Deadline creation',
      DeadlineCancel: 'Deadline cancel',
      DeadlineFullfill: 'Deadline fullfill',
      DeadlineEdit: 'Deadline edit',
    },
    typeResource: {
      AssignmentAdd: 'Assignment',
      AssignmentRemove: 'Assignment',
      GenericEdit: 'Edit',
      JudicialDataEdit: 'Judicial data',
      SubjectAdd: 'Subject',
      SubjectEdit: 'Subject',
      SubjectRemove: 'Subject',
      SubjectRestore: 'Subject',
      SubjectTransferToCase: 'Subject',
      PhaseTransition: 'Phase transition',
      DeadlineCreation: 'Deadline',
      DeadlineCancel: 'Deadline',
      DeadlineFullfill: 'Deadline',
      DeadlineEdit: 'Deadline',
    },
  },

  caseEvents: {
    eventType: 'Event type',
    createdBy: 'Created by',
    eventPayload: 'Event data',
    displayName: 'Name',
    eurValue: 'Case value',
    externalId: 'Identifier',
    portfolio: 'Portfolio',
    practice: 'Practice',
    unknown: 'Unknown',
    type: {
      GenericEdit: 'Edit',
      PortfolioChange: 'Portfolio change',
      PracticeAdd: 'Practice added',
      PracticeRemove: 'Practice removed',
      SubjectAdd: 'Subject added',
      SubjectEdit: 'Subject edited',
      SubjectRemove: 'Subject removed',
      SubjectRestore: 'Subject restored',
    },
    typeResource: {
      GenericEdit: 'Edit',
      PortfolioChange: 'Portfolio',
      PracticeAdd: 'Practice',
      PracticeRemove: 'Practice',
      SubjectAdd: 'Subject',
      SubjectEdit: 'Subject',
      SubjectRemove: 'Subject',
      SubjectRestore: 'Subject',
    },
  },

  subjects: {
    noSubjects: 'There are no subjects',
    caseSubject: 'Case subject',
    detailsTitle: 'Subject',
    type: 'Type',
    judicial: 'Judicial',
    contacts: 'Contacts',
    address: 'Address',
    email: 'E-mail',
    pec: 'PEC',
    telephone: 'Telephone',
    add: 'Create new subject',
    edit: 'Edit subject',
    records: 'Records',
    creationSteps: {
      person: 'Person',
      additionalData: 'Additional data',
    },
    remove: {
      button: 'Remove',
      title: 'Confirm subject remove',
      message: 'Are you sure you want to remove {displayName} from the subjects?',
    },
    transferToCase: {
      info: 'This subject is for this practice only. If you want to link it to the case and all the practices within it, you can transfer it to the case.',
      button: 'Transfer to case',
      title: 'Transfer subject to case',
      message: 'Do you want to transfer {displayName} to the case? This will link the subject to the case.',
    },
  },

  deadlines: {
    type: 'Type',
    displayName: 'Name',
    description: 'Description',
    duration: 'Duration',
    actualDate: 'Actual date',
    createMsEvent: 'Create event on Microsoft Calendar',
    dueType: 'Due type',
    dueTypes: {
      Absolute: 'Absolute',
      Relative: 'Relative',
    },
    absoluteDueSection: 'Absolute due date',
    relativeDueSection: 'Relative due date',
    dueDate: 'Due date',
    dueInterval: 'Due interval',
    dueIntervalUom: 'Unit of measurement',
    dueIntervalFrom: 'From',
    dueIntervalTimeOverride: 'Time override',
    fullfilledAt: 'Fullfilled at',
    fullfilledBy: 'Fullfilled by',
    canceledAt: 'Canceled at',
    canceledBy: 'Canceled by',
    users: 'Users',
    noUsers: 'There are no users assigned to this deadline',
    relativeDue: '{interval} {uom} from {relativeDeadline}',
    computedDueDateTooltip: 'Original due date: {date}',
    fullfill: 'Fullfill',
    fullfillDialog: {
      title: 'Fullfill confirm',
      message: 'Do you confirm that this deadline has been fullfilled?',
      transitionPhase: 'Transition phase',
    },
    cancel: 'Delete',
    cancelConfirm: {
      title: 'Cancel confirm',
      message: 'Do you confirm that this deadline should be canceled?',
    },
    editActualDate: 'Set actual date',
    msEvent: {
      true: 'Synced with Microsoft Calendar',
      false: 'Not synced with Microsoft Calendar',
    },
    reminder: 'Reminder',
    add: 'Add new deadline',
    edit: 'Edit deadline',
    practice: 'Practice',
    assignUser: {
      title: 'Assign user to deadline',
      user: 'User',
      practiceAssigned: 'Assigned to practice',
      others: 'Other users',
    },
    deassignUser: {
      title: 'Deassign user',
      message: 'Are you sure you want to deassign {user} from this deadline?',
    },
    columns: {
      label: 'Deadline',
      date: 'Due date',
      practice: 'Practice',
      users: 'Users',
    },
    filters: {
      title: 'Deadline filters',
      searchString: 'Name',
      type: 'Deadline type',
      status: 'Status',
      users: 'Users',
      badge: 'Badge',
      mine: 'Assigned to me',
      unassigned: 'Unassigned',
      assignment: 'Assignment',
      others: 'Others',
      statuses: {
        unfulfilled: 'Unfulfilled',
        fulfilled: 'Fulfilled',
        canceled: 'Canceled',
      },
    },
    badge: 'Badge',
    badgeEditDialog: {
      title: 'Edit deadline badge',
    },
    badges: {
      title: 'Deadline badges',
      displayName: 'Name',
      color: 'Color',
      visible: 'Visible',
      add: 'Create new deadline badge',
      edit: 'Edit deadline badge',
    },
  },

  pctEvents: {
    description: 'Description',
    registry: 'Registry',
    registryNote: 'Registry note',
    details: {
      documents: 'Documents',
      attachments: 'Attachments',
      title: 'PCT event',
      description: 'Description',
      date: 'Creation date',
      syncDate: 'Sync date',
    },
    errors: {
      title: 'Synchronization error',
      outOfSync: 'The practice is out of sync with the PCT',
      syncError: 'An error occurred during the synchronization with the PCT',
    },
  },

  taskTypes: {
    title: 'Task types',
    add: 'Create new task type',
    edit: 'Edit task type',
    name: 'Name',
    visible: 'Visible',
  },

  tasks: {
    title: 'Tasks',
    add: 'New task',
    edit: 'Edit task',
    type: 'Task type',
    text: 'Text',
    assignee: 'Assignee',
    expiration: 'Expiration date',
    fulfill: 'Fulfill',
    cancel: 'Revoke',
    noPractice: 'No practice associated',
    filters: {
      title: 'Task filters',
      status: 'Status',
      assignment: 'Assignment',
      type: 'Type',
      unassigned: 'Unassigned',
      mine: 'Mine',
      others: 'Others',
      statuses: {
        pending: 'To do',
        fulfilled: 'Fulfilled',
        canceled: 'Canceled',
      },
    },
    status: {
      pending: 'To do',
      fulfilled: 'Fulfilled',
      canceled: 'Canceled',
    },
    column: {
      task: 'Task',
      expiration: 'Expiration date',
      status: 'Status',
      type: 'Type',
      practice: 'Practice',
      assignee: 'Assignee',
      fulfilledAt: 'Fulfilled',
      canceledAt: 'Canceled',
    },
    details: {
      text: 'Text',
      expiration: 'Expiration date',
      practice: 'Practice',
      assignee: 'Assignee',
      events: 'Events',
      createdBy: 'Created by',
      fulfilledBy: 'Fulfilled by',
      canceledBy: 'Canceled by',
    },
    fulfillDialog: {
      title: 'Fulfill confirm',
      message: 'Are you sure you want to mark this task as fulfilled?',
    },
    cancelDialog: {
      title: 'Cancel confirm',
      message: 'Are you sure you want to mark this task as canceled?',
    },
    clickToAssign: 'Click to assign',
    assignDialog: {
      title: 'Assign task',
    },
  },

  subjectTypes: {
    title: 'Subject types',
    add: 'Create new subject type',
    edit: 'Edit subject type',
    displayName: 'Name',
    color: 'Color',
    visible: 'Visible',
    section: 'Section',
    detailsTitle: 'Subject type',
    recordsTitle: 'Record types',
  },

  recordTypes: {
    title: 'Record types',
    caseRecordTypes: 'Case record types',
    add: 'Create new record type',
    edit: 'Edit record type',
    displayName: 'Name',
    tabular: 'Tabular',
    readRoles: 'Read roles',
    writeRoles: 'Write roles',
    detailsTitle: 'Record type',
    fieldsTitle: 'Specific fields',
    sortFields: 'Sort fields',
    rolesDialog: {
      readTitle: 'Edit read roles',
      writeTitle: 'Edit write roles',
      role: 'Role',
      noRoles: 'There are no roles configured',
    },
  },

  assignedRecordTypes: {
    title: 'Record types',
    recordType: 'Record type',
    add: 'Add new record type',
    removeHeader: 'Remove',
    removeMessage: 'Are you sure you want to remove "{displayName}" from the record types?',
    sort: 'Sort',
    sortTitle: 'Sort assigned record types',
  },

  persons: {
    title: 'Persons',
    displayName: 'Display name',
    fiscalCode: 'Fiscal code',
    vatCode: 'VAT code',
    email: 'E-mail',
    pec: 'PEC',
    telephone: 'Telephone',
    externalId: 'External ID',
    type: {
      Physical: 'Physical',
      Legal: 'Legal',
    },
    filters: {
      title: 'Person filters',
      searchString: 'Name, e-mail or fiscal code',
      externalId: 'External ID',
      type: 'Type',
      pctLawyer: 'Lawyer',
    },
    add: 'Create new person',
    edit: 'Edit person',
    mergeDialog: {
      title: 'Duplicate merge',
      description:
        'You are going to merge this person with the one that you select from the list below. This one will be deleted and all its occurrences in the subjects will be replaced with the selected person.',
      confirmMessage:
        'You are going to merge {duplicateName} with {targetName}. Are you sure you want to proceed? This action is irreversible.',
      confirmTitle: 'Confirm merge',
      button: 'Duplicate merge',
    },
  },

  personDetails: {
    person: 'Person',
    linkedPersons: 'Linked persons',
    linkedCompanies: 'Linked company',
    subjects: 'Appears in:',
    type: 'Type',
    pctLawyer: 'Lawyer',
    legalNature: 'Legal nature',
    legalNatureTooltip:
      'Indicates the type of legal form under which an entity, organization, or person operates according to the law.',
    displayName: 'Display name',
    title: 'Title',
    pctLawyerTooltip: 'Persons with this flag can be added to deposits as lawyers.',
    firstName: 'First name',
    lastName: 'Last name',
    createdAt: 'Registration date',
    externalId: 'External ID',
    fiscalCode: 'Fiscal code',
    contacts: 'Contacts',
    address: 'Address',
    street: 'Street',
    houseNumber: 'Nr.',
    city: 'City',
    province: 'Province',
    postalCode: 'ZIP code',
    country: 'Country',
    birthDate: 'Birth date',
    birthPlace: 'Birth place',
    vatCode: 'VAT code',
    paCode: 'PA code',
    email: 'E-mail',
    pec: 'PEC',
    telephone: 'Telephone',
    noSubjects: 'This person does not appear in any subject',
    noAssignedSubjects: 'This person does not appear in any subject visible to you',
    links: {
      add: 'Add linked person',
      noLinks: 'This person has no links',
      removeConfirmTitle: 'Confirm remove',
      removeConfirmMessage: 'Are you sure you want to remove {displayName} from the linked persons?',
    },
  },

  reports: {
    title: 'Reports',
    download: 'Download',
    add: 'Generate new report',
    type: 'Type',
    format: 'Format',
  },

  massiveEmailTypes: {
    title: 'Massive e-mail types',
    displayName: 'Name',
    color: 'Color',
    add: 'Create new massive e-mail type',
    edit: 'Edit massive e-mail type',
  },

  massiveEmails: {
    title: 'Massive e-mails',
    send: 'Send',
    close: 'Close',
    alreadySent: 'The e-mail has already been sent',
    sendDialog: {
      title: 'Send confirm',
      message: 'Are you sure you want to proceed with the send of "{name}" massive e-mail?',
    },
    closeDialog: {
      title: 'Close confirm',
      message: 'Are you sure you want to close "{name}" massive e-mail? Subsequent responses will not be registered.',
    },
    phase: {
      draft: 'Draft',
      sent: 'Sent',
      closed: 'Closed',
    },
    add: 'Create new massive e-mail',
    edit: 'Edit massive e-mail',
  },

  toolRuns: {
    title: 'Tool runs',
    toolKey: 'Key',
    toolVersion: 'Version',
    eurPrice: 'Price',
    lastUpdate: 'Last update',
    add: 'Add new tool run',
    edit: 'Edit tool run',
    detailsTitle: 'Tool run',
    input: 'Input',
    output: 'Output',
    execute: 'Execute',
    status: {
      success: 'Success',
      error: 'Error',
      running: 'Running',
      draft: 'Draft',
    },
    confirmExecution: {
      title: 'Confirm execution',
      message:
        'Are you sure you want to execute the tool {toolKey}? It has a cost of {eurPrice} and the execution may take some time.',
    },
    error: 'Error',
    errorDetail: 'Error detail',
    errorMessage: 'Message',
  },

  massiveEmailDetails: {
    type: 'Type',
    displayName: 'Name',
    template: 'Template',
    redirectUrl: 'Redirect URL',
    created: 'Created',
    sent: 'Sent',
    closed: 'Closed',
    tabs: {
      events: 'Events',
      metadata: 'Metadata',
      preview: 'Preview',
      receivers: 'Receivers',
      responses: 'Responses',
    },
    subject: 'Subject',
    editSubject: 'Edit subject',
    metadata: {
      title: 'Metadata',
      removalTitle: 'Removal confirm',
      removalMessage: 'Are you sure you want to remove "{key}" from the metadata?',
      add: 'Add metadata',
      edit: 'Edit metadata "{key}"',
      key: 'Key',
      value: 'Value',
    },
    answers: {
      title: 'Answers',
      removalTitle: 'Removal confirm',
      removalMessage: 'Are you sure you want to remove "{label}: {value}" from the answers?',
      add: 'Add new answer',
      edit: 'Edit answer',
      value: 'Value',
      label: 'Label',
      extra: 'Extra',
      noExtra: 'No extra parameters have been set',
      extraKey: 'Key',
      extraValue: 'Value',
    },
    preview: {
      subject: 'Subject',
      body: 'Body',
      empty: 'Empty',
      rendered: 'Rendered',
    },
    responses: {
      filtersTitle: 'Responses filters',
      filterSearchString: 'E-mail, practice name or archive number',
      filterResponse: 'Response',
    },
    stats: {
      receivers: 'Receivers',
      responses: 'Responses',
    },
  },

  massiveEmailReceivers: {
    add: 'Add new receivers',
    import: 'Import receivers',
    sourceFile: 'Source file (*.xlsx)',
    sourceFileDescription:
      'The source file must contain the "practiceId" and "emailAddresses" columns. Other columns will be treated as metadata',
    metadata: 'Metadata',
    replace: 'Replace',
    replaceDescription:
      'By selecting the replace option, the receivers that are not in the provided file will be removed from the list',
    steps: {
      practice: 'Practice',
      addresses: 'Addresses',
    },
    filters: {
      title: 'Receivers filters',
      searchString: 'E-mail, practice name or archive number',
    },
    remove: {
      title: 'Removal confirm',
      message: 'Are you sure you want to remove "{address}" from the receivers list?',
    },
  },

  massiveImports: {
    title: 'Massive imports',
    status: {
      success: 'Success',
      error: 'Error',
      running: 'Running',
    },
    errorMessage: 'Error message',
    report: 'Report',
    add: 'New massive import',
    type: 'Type',
    sourceFile: 'Source file',
    replace: 'Replace',
    practiceType: 'Practice type',
    customerFiscalCode: 'Customer fiscal code',
    customerSubjectType: 'Customer subject type',
    customerManagerSubjectType: 'Customer manager subject type',
    debtorSubjectType: 'Debtor subject type',
    lawyerSubjectType: 'Lawyer subject type',
    subjectType: 'Subject type',
    recordType: 'Record type',
    recordFieldKey: 'Record field',
    minDate: 'Minimum date',
  },

  pct: {
    title: 'Polisweb',
    notFound: 'Practice not found on the Polisweb',
    notPermitted:
      'The practice cannot be downloaded from the Polisweb.\nError code: {errorCode}\nError message: {errorMessage}',
    error: 'An error occurred while trying to download the practice from the Polisweb.',
  },

  pctDeposits: {
    title: 'PCT Deposits',
    add: {
      title: 'New deposit',
      type: 'Type',
      urgent: 'Urgent',
      court: 'Court',
      registry: 'Registry',
      generalRoleNumber: 'General role number',
      externalDeposit: 'External deposit',
      externalNote: 'If the deposit type is not yet supported, you can submit it with a third-party software.',
    },
    editUrgent: 'Edit urgency',
    editReferenceText: 'Edit reference',
    editDemand: 'Edit demand',
    editNotes: 'Edit notes',
    editNominaConsulente: 'Edit consultant nomination',
    editInstances: 'Edit instances',
    editDevices: 'Edit devices',
    editPartyFiscalCode: 'Edit party fiscal code',
    partyFiscalCode: 'Party fiscal code',
    notes: 'Notes',
    referenceText: 'Reference',
    demand: 'Demand',
    device: 'Device',
    instances: 'Instances',
    otherInstances: '+{count} more instances',
    notaSpese: {
      compensi: 'Fees',
      speseEsenti: 'Exempt expenses',
      speseGenerali: 'General expenses',
      speseImponibili: 'Taxable expenses',
    },
    ricusazioneCtu: {
      ctuCodiceFiscale: 'CTU fiscal code',
    },
    type: 'Type',
    status: 'Status',
    user: 'User',
    court: 'Court',
    pecId: 'PEC ID',
    filters: {
      title: 'Deposit filters',
    },
    generalRoleNumber: 'General role number',
    judicialData: 'Judicial data',
    practice: 'Practice',
    createdAt: 'Creation date',
    sentAt: 'Send date',
    statuses: {
      draft: 'Draft',
      sent: 'Sent',
      locked: 'Locked',
    },
    detailsTitle: 'PCT Deposit [{pecId}]',
    parties: {
      title: 'Edit personal details',
      personDetails: 'Personal details',
      fiscalCode: 'Fiscal code',
      fiscalCodeMessage: 'The fiscal code is required',
      role: 'Role',
      deleteTitle: 'Confirm delete',
      deleteMessage: 'Are you sure you want to delete {displayName} from the deposit?',
      represents: 'Represents',
    },
    partyCreationSteps: {
      role: 'Role',
      person: 'Person',
      additionalData: 'Additional data',
    },
    partyRoles: {
      Parte: 'Party',
      Chiamato: 'Called',
      Avvocato: 'Lawyer',
      Consulente: 'Consultant',
    },
    representedParties: 'Represented parties',
    consultantNomination: 'Consultant nomination',
    delete: {
      title: 'Confirm delete',
      message: 'Are you sure you want to delete this deposit?',
    },
    attachments: {
      title: 'Attachments',
      add: 'Add new attachment',
      addSignatureWarning:
        'Important: if the attachment is not signed, it will be automatically signed during the upload process.',
      delete: {
        title: 'Confirm delete',
        message: 'Are you sure you want to delete the attachment "{name}"?',
      },
      addErrors: {
        duplicateMain: 'There can be only one main attachment',
        duplicateFilename: 'An attachment with the same name already exists',
        mainNotSigned: 'The main attachment must be a signed PDF',
        resourceNotSigned: 'This type of attachment must be signed',
        generic: 'An error occurred while uploading the attachment',
      },
      signErrors: {
        generic: 'An error occurred while signing the attachment',
        alreadyRunning: 'The attachment is already being signed, please wait',
      },
      sign: {
        title: 'Sign attachment',
        message: 'Are you sure you want to sign the "{name}" attachment?',
      },
      main: 'Main attachment',
      notMain: 'Other',
      datiAtto: 'Structure file',
      signed: 'Signed',
      inputLabel: 'Select a file to upload',
      downloadDatiAtto: 'Download DatiAtto.xml',
      generateSignedDatiAtto: 'Generate signed DatiAtto.xml',
      contextMenu: {
        view: 'View',
        download: 'Download',
        delete: 'Delete',
        sign: 'Sign',
      },
    },
    checks: {
      title: 'Checks',
      outcome: 'Outcome',
      types: {
        PecAcceptance: 'PEC Acceptance',
        PecDelivery: 'PEC Delivery',
        AutomaticChecks: 'Automatic Checks',
        Acceptance: 'Acceptance',
      },
    },
    send: {
      button: 'Send',
      confirmTitle: 'Confirm send',
      confirmMessage: 'Are you sure you want to send the deposit to {court} with number {rg}?',
    },
  },

  apbPractices: {
    title: 'APB Practices',
    practiceName: 'Name',
    practiceCourt: 'Court',
    practiceRegistrationNumber: 'RG',
    operatorsEmail: 'E-mails',
    practiceExternalId: 'External ID',
    filters: {
      title: 'Practice filters',
      name: 'Name',
      court: 'Court',
      registrationNumber: 'RG',
      externalId: 'External ID',
      operatorsEmail: 'E-mails',
    },
  },

  apbProcessedEmails: {
    title: 'APB Processed E-mails',
    detailsTitle: 'APB E-mail',
    sender: 'Sender',
    subject: 'Subject',
    date: 'Received',
    processedAt: 'Processed',
    forwarded: 'Forwarded',
    forwardedTo: 'Forwarded To',
    detection: 'Detection',
    tag: 'Tag',
    tags: {
      Closeout: 'Closeout',
      Outcome: 'Outcome',
      Mediation: 'Mediation',
      Other: 'Other',
      TooBig: 'Too big',
    },
    filters: {
      title: 'E-mail filters',
      sender: 'Sender',
      subject: 'Subject',
      forwardedTo: 'Forwarded To',
      tag: 'Tag',
    },
    unknownUser: 'Unknown',
    newProcessing: {
      title: 'New processing',
      button: 'New processing',
      description: 'This procedure allows you to process the e-mails that have not been processed on the provided day',
      onlyOnDate: 'Date',
    },
  },

  errorFallbackDefault: {
    title: 'Oops! Something went wrong.',
    message: "We're sorry, an error occurred while loading the page. Please try again later.",
    button: 'Reload the page',
  },

  errorServer: {
    title: 'Oops! A server error has occurred!',
    message: 'For any assistance, contact {email}',
    button: 'Reload the page',
  },

  errorFallbackUnauthorized: {
    title: 'Access Denied',
    message: 'Sorry, you are not authorized to access this page or your session has expired.',
    messageSecondary: 'You will be automatically redirected to the login page in {seconds} seconds.',
    button: 'Go to Login Page',
  },

  notFound: {
    code: '{code}',
    message: 'Oops! The page you are looking for does not exist.',
    button: 'Go to Home',
  },

  profile: {
    title: 'Personal profile',
    personalSettings: 'Personal settings',
    locale: 'Locale',
    locales: {
      'it-IT': 'Italian',
      'en-US': 'English',
    },
  },

  passwordChange: {
    passwordChange: 'Change password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    passwordChanged: 'Password changed!',
  },

  passwordStrength: {
    empty: 'Type password',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
  },

  firstPasswordChange: {
    title: 'Set up a New Password',
    body: 'Welcome! The password you used was provided by the administrator for your first login.\nFor security reasons, please set a new password for future access. You can always change it later from the profile page.',
  },

  /* cspell:ignore BRZJJA,Vetere,DIOAI */
  placeholders: {
    address: 'Roma street, 1, 30100 Verona VR, Italy',
    answerExtraKey: 'description',
    answerExtraValue: 'Of course i would like to accept!',
    answerLabel: 'Yes',
    answerValue: '1',
    archiveNumber: '123-123',
    choose: 'Choose',
    city: 'Verona',
    country: 'Italy',
    courts: 'Santa Maria Capua Vetere',
    deadline: 'Deadline',
    deadlineTypeCategory: 'Hearing, fulfillment, other',
    description: 'Description...',
    displayName: 'Mark Spenser',
    duration: 'hh:mm',
    email: "{'username@domain.com'}",
    eurValue: '100.00',
    externalId: '1234',
    externalIdLabel: 'Customer ID',
    fieldDisplayName: 'Proposed amount',
    fieldKey: 'proposed_amount',
    firstName: 'Mark',
    fiscalCode: 'BRZJJA24M22G722E',
    generalRoleNumber: '1234/2024',
    houseNumber: '10',
    lastName: 'Spenser',
    metadataKey: 'intro_1',
    metadataValue: 'Kind colleague,',
    officeCode: '1234567890',
    pec: "{'usernamepec@domainpec.com'}",
    personTitle: 'Mr.',
    phaseName: 'Study',
    postalCode: '30100',
    practiceDisplayName: 'Alma Iura against Mark Spenser',
    practiceType: 'Mediation',
    province: 'VR',
    recordType: 'Contract',
    roleDescription: 'Description...',
    roleName: 'Administrator',
    roleSelect: 'Select a role',
    search: 'Search',
    section: 'Section A',
    settingVariableName: 'JsWT_SECRET_2',
    settingVariableValue: 'ygKm0ZdDIOAI2',
    street: 'Roma street',
    subject: "Reach out for practice {'{{practiceName}}'}",
    subjectType: 'Debtor',
    taskText: 'Task text...',
    taskType: 'Check document',
    telephone: '343 444 3344',
    url: 'https://aird-web.almaiura.it',
    vatCode: 'IT11111111111',
    paCode: 'Max 16 characters',
  },
}
